import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import './style.css';

const lensContent = ReactDOM.createRoot(document.getElementById("lens-content"));
lensContent.render(<App />);
